import React from "react";
import "./TimeRecordsTable.css";

const TimeRecordsTable = ({ records, loading }) => {
  return (
    <div className="time-table-container">
      <h2>User Time Records</h2>

      {loading ? (
        <div className="spinner-container">
          <div className="spinner" />
          <p>Loading your time records…</p>
        </div>
      ) : records.length === 0 ? (
        <p>No records found.</p>
      ) : (
        <table className="time-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Date</th>
              <th>Hours Worked</th>
              <th>Project</th>
              <th>Activity</th>
            </tr>
          </thead>
          <tbody>
            {records.map((record, index) => {
              const dateOnly = record.TimesheetDate
                ? new Date(record.TimesheetDate).toLocaleDateString("en-GB")
                : "Invalid Date";

              // Build a stable key: prefer a provided id; otherwise use a composite
              // of fields that uniquely identify a timesheet row for this UI.
              const stableKey =
                record.TimesheetID ||
                `${(record.UserID || "").trim()}|${record.TimesheetDate}|${index}`;

              return (
                <tr key={stableKey}>
                  <td>{record.UserCode || "Unknown"}</td>
                  <td>{dateOnly}</td>
                  <td>{record.TimesheetHours ?? 0}</td>
                  <td style={{ position: "relative" }}>
                    {record.ProjectCode || "-"}
                    <div className="ts-note-tooltip">
                      {record.TimesheetNotes ||
                        "No Note"}
                    </div>
                    <div style={{ color: "#666", fontSize: 12, marginLeft: 8 }}>
                      {record.TimesheetNotes
                        ? "Note"
                        : "No Note"}
                    </div>
                  </td>
                  <td>{record.ActivityCode || "-"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TimeRecordsTable;
